const dashboardMock = {
  source: 'mock',
  generatedAt: '2026-09-19T21:04:00-03:00',
  periodLabel: 'Hoje · 19/09/2026',
  eventYear: 2026,
  kpis: {
    reads: 186,
    uniqueInvites: 154,
    validated: 142,
    alreadyValidated: 28,
    invalid: 16,
    alerts: 19,
  },
  hourly: [
    { hour: '16h', validated: 8, alreadyValidated: 1, invalid: 2 },
    { hour: '17h', validated: 21, alreadyValidated: 3, invalid: 2 },
    { hour: '18h', validated: 34, alreadyValidated: 6, invalid: 4 },
    { hour: '19h', validated: 41, alreadyValidated: 8, invalid: 3 },
    { hour: '20h', validated: 27, alreadyValidated: 7, invalid: 3 },
    { hour: '21h', validated: 11, alreadyValidated: 3, invalid: 2 },
  ],
  recent: [
    { at: '21:03:41', number: '0219', code: 'kGiJcbLcTt', status: 'validated', msg: 'Convite validado com sucesso', alerta: 'Cortesia camarote' },
    { at: '21:02:18', number: '0144', code: 'pQ8nRm2xLk', status: 'already', msg: 'Convite já validado', alerta: '' },
    { at: '21:01:55', number: '0002', code: '8m0Ijl9tck', status: 'already', msg: 'Convite já validado', alerta: '' },
    { at: '21:00:12', number: '0881', code: 'aT3vYc9hWp', status: 'validated', msg: 'Convite validado com sucesso', alerta: '' },
    { at: '20:58:47', number: '', code: 'XXXXINVALID', status: 'invalid', msg: 'Convite inexistente', alerta: '' },
    { at: '20:57:09', number: '0310', code: 'mL6bKs1dFq', status: 'validated', msg: 'Convite validado com sucesso', alerta: 'Imprensa' },
    { at: '20:55:33', number: '0067', code: 'zR4nHc8uEj', status: 'validated', msg: 'Convite validado com sucesso', alerta: '' },
    { at: '20:54:02', number: '0198', code: 'wN2gPa7sYt', status: 'already', msg: 'Convite já validado', alerta: 'Acesso especial' },
  ],
  alerts: [
    { at: '21:03:41', number: '0219', code: 'kGiJcbLcTt', alerta: 'Cortesia camarote' },
    { at: '20:57:09', number: '0310', code: 'mL6bKs1dFq', alerta: 'Imprensa' },
    { at: '20:54:02', number: '0198', code: 'wN2gPa7sYt', alerta: 'Acesso especial' },
    { at: '20:41:16', number: '0075', code: 'cV9qTd5nXo', alerta: 'Cortesia pista' },
    { at: '20:22:48', number: '0520', code: 'hB1mUf4rJk', alerta: 'Produtora' },
  ],
  topRepeats: [
    { number: '0002', code: '8m0Ijl9tck', count: 5 },
    { number: '0144', code: 'pQ8nRm2xLk', count: 3 },
    { number: '0198', code: 'wN2gPa7sYt', count: 3 },
    { number: '0067', code: 'zR4nHc8uEj', count: 2 },
  ],
};

export default dashboardMock;
